import { FC } from 'react';
import { Block } from './Opacity.style';

export const Opacity: FC<{ elementsCount?: number }> = ({ children }) => {
  return <Block>{children}</Block>;
};
